import appConfig from 'appConfig';
import TreeContrast from '../treeContrast/treeContrast.vue'; //树控件
export default {
  name: 'multiContrast',
  data() {
    return {
      baseMapLayer1: "",
      baseMapLayer2: "",
      baseMapLayer3: "",
      baseMapLayer4: "",
      baseMapImgLayer1: "",
      baseMapImgLayer2: "",
      baseMapImgLayer3: "",
      baseMapImgLayer4: "",
      baseMapFontLayer1: "",
      baseMapFontLayer2: "",
      baseMapFontLayer3: "",
      baseMapFontLayer4: "",
      mapData1: {},
      mapData2: {},
      mapData3: {},
      mapData4: {},
      treeC1:false,
      treeC2:false,
      treeC3:false,
      treeC4:false,
      projection: this.$olmap.proj.get(appConfig.map.proj),
      zindex: 300
    };

  },
  components: {
    TreeContrast,
  },
  computed: {},
  props: {
  },
  watch: {
  },
  mounted() {
    if (appConfig.map.isProj) {
      // 度
      this.projection = new this.$olmap.proj.Projection({ 
        code: appConfig.map.proj, 
        units: this.$olmap.proj.Units.METERS, 
        extent: extent 
      });
    }
    this.initMap();
  },
  created() {
    this.configMap = appConfig.map;
  },
  methods: {
    initMap() {
      // 特殊空间参考注册
			var extent = [-180,-90,180,90]
			proj4.defs(appConfig.map.proj, appConfig.map.defsCode);
			//投影坐标系
			var projection = new this.$olmap.proj.Projection({ code: appConfig.map.proj, units: this.$olmap.proj.Units.METERS, extent: extent });
			//中心点
			var center = this.$olmap.extent.getCenter(extent);
      var resolutions = appConfig.map.resolutions.reso;
      // 左上角地图容器服务
      this.mapData1 = new this.$olmap.Map({
        logo: false,
        target: 'leftMap',
        layers: [],
        controls: this.$olmap.control.defaults({
          attribution: false,
          rotate: false,
          zoom: false,
        }),
        view: new this.$olmap.View({
          center: [appConfig.map.center.lng, appConfig.map.center.lat],
          zoom: appConfig.map.zoom,
          projection: projection,
        }),
      });
      // 右上角地图容器
      this.mapData2 = new this.$olmap.Map({
        logo: false,
        target: 'rightMap',
        layers: [],
        controls: this.$olmap.control.defaults({
          attribution: false,
          rotate: false,
          zoom: false,
        }),
        view: this.mapData1.getView(),
      });
      // 左下角地图的容器
      this.mapData3 = new this.$olmap.Map({
        logo: false,
        target: 'leftMap2',
        layers: [],
        controls: this.$olmap.control.defaults({
          attribution: false,
          rotate: false,
          zoom: false,
        }),
        view: this.mapData1.getView(),
      });
      // 右下角的地图容器
      this.mapData4 = new this.$olmap.Map({
        logo: false,
        target: 'rightMap2',
        layers: [],
        controls: this.$olmap.control.defaults({
          attribution: false,
          rotate: false,
          zoom: false,
        }),
        view: this.mapData1.getView(),
      });
      for (var i = 1; i < 5; i++) {
        var mapData = "mapData" + i;
        var baseMapImg = "baseMapImgLayer" + i;
        var baseMapLay = "baseMapLayer" + i;
        var baseMapFont = "baseMapFontLayer" + i;
        this.addBaseMap(this[mapData], baseMapImg, baseMapLay, baseMapFont,resolutions);
        this[baseMapImg].setVisible(false);
      }
    },


    addBaseMap(map, baseMapImgLayer, baseMapLayer, baseMapFontLayer, resolutions) {
      if (appConfig.baseLayersConfig.vectorMap) {
        // 矢量底图
        this.zindex ++
        var type = appConfig.baseLayersConfig.vectorMap.type;
        switch (type) {
          case "layer.ImageArcGISRest":
            this[baseMapLayer]  = this.publicMethod.getImageArcGISRest(appConfig.baseLayersConfig.vectorMap , this.zindex , this.$olmap);
            break;
          case "layer.TileArcGISRestXYZ":
            this[baseMapLayer]  = this.publicMethod.getArcgisXYZTile(appConfig.baseLayersConfig.vectorMap,appConfig.map.origin, resolutions ,this.zindex,
              this.$olmap , this.projection , [appConfig.map.extent.XMin, appConfig.map.extent.YMin, appConfig.map.extent.XMax, appConfig.map.extent.YMax]);
            break;
          case "layer.TileArcGISRest":
            this[baseMapLayer]  = this.publicMethod.getTileArcGISRestLayer(appConfig.baseLayersConfig.vectorMap , appConfig.map.origin , resolutions , [appConfig.map.extent.XMin, appConfig.map.extent.YMin, appConfig.map.extent.XMax, appConfig.map.extent.YMax],
              this.projection , this.$olmap);
            break;
          case "layer.TileArcGISRestTD":
            this[baseMapLayer]  = this.publicMethod.getArcgisXYZTileTD(appConfig.baseLayersConfig.vectorMap, this.zindex ,  this.$olmap);
            break;
          default:
            break;
        }
       map.addLayer(this[baseMapLayer] )
      }

      if (appConfig.baseLayersConfig.imageMap) {
        // 矢量底图
        this.zindex ++
        var type = appConfig.baseLayersConfig.imageMap.type;
        switch (type) {
          case "layer.ImageArcGISRest":
            this[baseMapImgLayer]= this.publicMethod.getImageArcGISRest(appConfig.baseLayersConfig.imageMap , this.zindex , this.$olmap);
            break;
          case "layer.TileArcGISRestXYZ":
            this[baseMapImgLayer]  = this.publicMethod.getArcgisXYZTile(appConfig.baseLayersConfig.imageMap,appConfig.map.origin, resolutions ,this.zindex,
              this.$olmap , this.projection , [appConfig.map.extent.XMin, appConfig.map.extent.YMin, appConfig.map.extent.XMax, appConfig.map.extent.YMax]);
            break;
          case "layer.TileArcGISRest":
            this[baseMapImgLayer]= this.publicMethod.getTileArcGISRestLayer(appConfig.baseLayersConfig.imageMap , appConfig.map.origin , resolutions , [appConfig.map.extent.XMin, appConfig.map.extent.YMin, appConfig.map.extent.XMax, appConfig.map.extent.YMax],
              this.projection , this.$olmap);
            break;
          case "layer.TileArcGISRestTD":
            this[baseMapImgLayer]= this.publicMethod.getArcgisXYZTileTD(appConfig.baseLayersConfig.imageMap, this.zindex ,  this.$olmap);
            break;
          default:
            break;
        }
       map.addLayer(this[baseMapImgLayer])
      }

      if (appConfig.baseLayersConfig.vectorFontMap) {
        // 矢量底图
        this.zindex ++
        var type = appConfig.baseLayersConfig.vectorFontMap.type;
        switch (type) {
          case "layer.TileArcGISRestTD":
            this[baseMapFontLayer] = this.publicMethod.getArcgisXYZTileTD(appConfig.baseLayersConfig.vectorFontMap, this.zindex ,  this.$olmap);
            break;
          case "layer.ImageArcGISRest":
            this[baseMapFontLayer] = this.publicMethod.getImageArcGISRest(appConfig.baseLayersConfig.vectorFontMap , this.zindex , this.$olmap);
            break;
          case "layer.TileArcGISRestXYZ":
            this[baseMapFontLayer] = this.publicMethod.getArcgisXYZTile(appConfig.baseLayersConfig.vectorFontMap,appConfig.map.origin, resolutions ,this.zindex,
              this.$olmap , this.projection , [appConfig.map.extent.XMin, appConfig.map.extent.YMin, appConfig.map.extent.XMax, appConfig.map.extent.YMax]);
            break;
          default:
            break;
        }
       map.addLayer(this[baseMapFontLayer])
      }
    },

    //构造天地图底图
    getArcgisXYZTileTD(item) {
      let url = item.url;
      var layer = new this.$olmap.layer.Tile({
        id: item.id,
        source: new this.$olmap.source.XYZ({
          url: url,
          crossOrigin: 'anonymous',//防止地图打印出现问题
        }),
      });
      return layer;
    },

    showswitchmap(type) {
      $('#mapType-wrapper' + type).addClass('expand');
    },
    switchmap(type) {
      $('#mapType-wrapper' + type).removeClass('expand');
    },
    // 天地图影像和矢量图层切换-显示矢量图层
    showvector(type) {
      this.commonShow(type, true);
      $('.expand #mapType' + type + ' .normal').addClass('active');
    },
    //天地图影像和矢量图层切换-显示影像图层
    showimagelayer(type) {
      this.commonShow(type, false);
      $('.expand #mapType' + type + ' .earth').addClass('active');
    },
    commonShow(type, istrue) {
      $('#mapType' + type).find('.active').removeClass('active');
      var baseMapImg = "baseMapImgLayer" + type;
      this[baseMapImg].setVisible(!istrue);
      var baseMapLay = "baseMapLayer" + type;
      this[baseMapLay].setVisible(istrue);
    },
    changeTree(index,type)
    {
      this["treeC"+index] =type;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/contrastComponent/multiContrast/multiContrast.js